import { Root } from '@makemydeal/dr-activities-desking';
import { DESKING_ROUTE_ROOT } from '../constants';

const DeskingActivity = () => {
    return <Root baseRoute={DESKING_ROUTE_ROOT} />;
};

export default DeskingActivity;
